import { getFileUrl } from '@/clients/http'
import { Image as ImageIcon } from 'lucide-react'

import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import { Button } from '@/components/ui/button'

interface ImageFieldProps {
  field: FieldSchema
  value: string
  onChange: (value: string) => void
  onImageRequest: (path: string) => void
  path: string
}

export const ImageField = ({ field, value, onChange, onImageRequest, path }: ImageFieldProps) => {
  return (
    <div className="space-y-3">
      {value ? (
        <div className="relative aspect-video rounded-xl border overflow-hidden group">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={getFileUrl(value)} className="w-full h-full object-cover" alt={field.label} />
          <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
            <Button size="sm" variant="secondary" onClick={() => onImageRequest(path || field.key)}>
              Change
            </Button>
            <Button size="sm" variant="destructive" onClick={() => onChange('')}>
              Remove
            </Button>
          </div>
        </div>
      ) : (
        <Button
          variant="outline"
          className="w-full h-32 border-dashed border-2 flex flex-col gap-2 hover:bg-primary/5 hover:border-primary/50 transition-all rounded-xl"
          onClick={() => onImageRequest(path || field.key)}
        >
          <div className="p-2 bg-muted rounded-full">
            <ImageIcon className="h-5 w-5 text-muted-foreground" />
          </div>
          <span className="text-overline uppercase text-muted-foreground">
            Select {field.label}
          </span>
        </Button>
      )}
    </div>
  )
}
